var svgxuse = require('svgxuse'), //jshint ignore:line
    // ^ ie11 ployfill
    fluidvids = require('./fluidvids.js')(),
    sortable = require('../libs/sortable.js');

//fluidvids global
fluidvids.init({
  selector: ['iframe', 'object'], // runs querySelectorAll()
  players: ['www.youtube.com', 'player.vimeo.com'] // players to support
});


(function openExternalLinksInNewWindow(window) {

    const domain = window.location.host
        .replace(/\./gi, "\\.");

    const domainFilterRegexp = new RegExp("^(www\\.)?" + domain + "$", "gim");

    const matches = window.document.querySelectorAll("a[href^='http://'], a[href^='https://']");

    if ("NodeList" in window && !NodeList.prototype.forEach) {

        NodeList.prototype.forEach = function (callback, thisArg) {
            thisArg = thisArg || window;

            for (let i = 0; i < this.length; i++) {
                callback.call(thisArg, this[i], i, this);
            }
        };
    }

    matches.forEach(function (link) {

        if (!domainFilterRegexp.test(link.host)) {

          let sortable = link.classList.contains('sortable');

            if (link === undefined || link.target === "" && !sortable) {
                link.target = "_blank";
            }
        }
    });

}(window));



// WEBPACK FOOTER //
// ./CMS/NationalGuild/src/js/components/globalInits.js